import tagTester from './_tagTester.js';

export default tagTester('Error');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isError.js
// module id = 1334
// module chunks = 9